import React from "react";
import { Stack, TextField, Button } from "@mui/material";

interface Props {
  searchTerm: string;
  onSearchChange: (v: string) => void;
  onNew: () => void;
  newBtnLabel?: string;
  placeholder: string;
}

const SearchBarWithButton: React.FC<Props> = ({
  searchTerm,
  onSearchChange,
  onNew,
  newBtnLabel,
  placeholder,
}) => {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2, mt: 2, justifyContent: "center" }}>
      <TextField
        size="medium"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ width: "70%" }}
      />
      <Button
        variant="contained"
        onClick={onNew}
        sx={{
          backgroundColor: "#1DA1F2",
          textTransform: "none",
          width: "30%",
          fontSize: "16px",
        }}>
        {newBtnLabel}
      </Button>
    </Stack>
  );
};

export default SearchBarWithButton;
